import { render, staticRenderFns } from "./InsuranceCard.vue?vue&type=template&id=dd66c27a"
import script from "./InsuranceCard.vue?vue&type=script&lang=js"
export * from "./InsuranceCard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCard.vue?vue&type=style&index=0&id=dd66c27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports